// Cambridge A2 Flyers week_37_real.js (Restored Syllabus Data)
export default {
  "weekId": 37,
  "title": "Living vs. Non-Living — CLIL Unit 6 Nature's Rules",
  "title_vi": "Vật Sống & Không Sống — Quy Luật Tự Nhiên CLIL Unit 6",
  "target_vocab": [
    {
      "word": "living",
      "definition_en": "Having life; alive and active",
      "definition_vi": "vật sống",
      "example": "A puppy is a living organism.",
      "ipa": "/ˈlɪv.ɪŋ/"
    },
    {
      "word": "non-living",
      "definition_en": "Not alive; matter that does not grow or breathe",
      "definition_vi": "vật không sống",
      "example": "A grey rock is a non-living object.",
      "ipa": "/nɒnˈlɪv.ɪŋ/"
    },
    {
      "word": "breathe",
      "definition_en": "To take air into the lungs and expel it",
      "definition_vi": "thở, hít thở",
      "example": "Living animals breathe fresh air.",
      "ipa": "/briːð/"
    },
    {
      "word": "grow",
      "definition_en": "To increase in size and develop",
      "definition_vi": "lớn lên, phát triển",
      "example": "Trees grow bigger with sunlight.",
      "ipa": "/ɡrəʊ/"
    },
    {
      "word": "need",
      "definition_en": "To require something essential for life",
      "definition_vi": "cần thiết",
      "example": "Plants need water and sunlight.",
      "ipa": "/niːd/"
    },
    {
      "word": "food",
      "definition_en": "Substance consumed to provide nutritional support",
      "definition_vi": "thức ăn",
      "example": "Animals eat food to get energy.",
      "ipa": "/fuːd/"
    },
    {
      "word": "water",
      "definition_en": "Essential clear liquid necessary for life",
      "definition_vi": "nước uống",
      "example": "All living things require water.",
      "ipa": "/ˈwɔː.tər/"
    },
    {
      "word": "rock",
      "definition_en": "Solid mineral material forming part of the earth",
      "definition_vi": "tảng đá",
      "example": "A rock is non-living because it does not grow.",
      "ipa": "/rɒk/"
    },
    {
      "word": "plastic",
      "definition_en": "Synthetic non-living material",
      "definition_vi": "chất nhựa",
      "example": "A plastic car is a non-living toy.",
      "ipa": "/ˈplæs.tɪk/"
    },
    {
      "word": "reproduce",
      "definition_en": "To produce offspring or new organisms",
      "definition_vi": "sinh sản",
      "example": "Living organisms can reproduce.",
      "ipa": "/ˌriː.prəˈdjuːs/"
    },
    {
      "word": "organism",
      "definition_en": "An individual living creature",
      "definition_vi": "sinh vật",
      "example": "A green plant is a living organism.",
      "ipa": "/ˈɔː.ɡən.ɪ.zəm/"
    },
    {
      "word": "energy",
      "definition_en": "Power derived from food or sunlight",
      "definition_vi": "năng lượng",
      "example": "Food gives living things energy.",
      "ipa": "/ˈen.ə.dʒi/"
    },
    {
      "word": "survive",
      "definition_en": "To continue to live or exist",
      "definition_vi": "tồn tại, sống sót",
      "example": "Animals need air to survive.",
      "ipa": "/səˈvaɪv/"
    },
    {
      "word": "air",
      "definition_en": "The invisible gaseous substance surrounding the earth",
      "definition_vi": "không khí",
      "example": "We breathe clean air.",
      "ipa": "/eər/"
    },
    {
      "word": "sunlight",
      "definition_en": "Light from the sun essential for plants",
      "definition_vi": "ánh nắng mặt trời",
      "example": "Plants absorb warm sunlight.",
      "ipa": "/ˈsʌn.laɪt/"
    },
    {
      "word": "plant",
      "definition_en": "A living organism such as a tree or flower",
      "definition_vi": "thực vật, cây xanh",
      "example": "A green plant is living.",
      "ipa": "/plɑːnt/"
    },
    {
      "word": "animal",
      "definition_en": "A living organism that feeds on organic matter",
      "definition_vi": "động vật",
      "example": "Animals are living organisms.",
      "ipa": "/ˈæn.ɪ.məl/"
    },
    {
      "word": "object",
      "definition_en": "A material thing that can be seen and touched",
      "definition_vi": "vật thể",
      "example": "A stone is a non-living object.",
      "ipa": "/ˈɒb.dʒɪkt/"
    },
    {
      "word": "environment",
      "definition_en": "The surroundings in which a living thing lives",
      "definition_vi": "môi trường",
      "example": "Organisms adapt to their environment.",
      "ipa": "/ɪnˈvaɪ.rən.mənt/"
    },
    {
      "word": "natural",
      "definition_en": "Existing in or caused by nature",
      "definition_vi": "tự nhiên",
      "example": "Rocks are natural non-living objects.",
      "ipa": "/ˈnætʃ.ər.əl/"
    }
  ],
  "story_missions": [
    {
      "mission_id": 1,
      "title": "Classifying Nature",
      "mission_context": "Explain why a puppy or tree is living using 'because' (it breathes/grows)."
    },
    {
      "mission_id": 2,
      "title": "Non-Living Objects",
      "mission_context": "Explain why a rock or plastic toy is non-living using 'because' (it does not eat/grow)."
    },
    {
      "mission_id": 3,
      "title": "Scientific Reasoning",
      "mission_context": "Present your CLIL Unit 6 science classification chart to the class."
    }
  ],
  "spark_talk": [
    {
      "topic_en": "Living Organisms",
      "topic_vi": "Sinh vật sống",
      "cards": [
        "Why is a puppy a living thing?",
        "What three things do plants need to survive?"
      ]
    },
    {
      "topic_en": "Non-Living Objects",
      "topic_vi": "Vật thể không sống",
      "cards": [
        "Is a rock living or non-living?",
        "How do you explain it using 'because'?"
      ]
    }
  ],
  "sentences": [
    "Welcome to CLIL Unit 6: Nature's Rules!",
    "Today young scientists classify living and non-living things.",
    "A puppy is living because it breathes fresh air and grows.",
    "A grey rock is non-living because it does not breathe or grow.",
    "An organism is living because it carries out vital life processes."
  ]
};
